import React, {Component} from 'react'
import Admin from './admin/Admin'
class App extends Component {
  render () {
    return (
      <>
        <style type='text/css'>{`
        @font-face {
          font-family: 'MaterialIcons';
          src: url(${require('react-native-vector-icons/Fonts/MaterialIcons.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'FontAwesome';
          src: url(${require('react-native-vector-icons/Fonts/FontAwesome.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'FontAwesome5_Brands';
          src: url(${require('react-native-vector-icons/Fonts/FontAwesome5_Brands.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'FontAwesome5_Regular';
          src: url(${require('react-native-vector-icons/Fonts/FontAwesome5_Regular.ttf')}) format('truetype');
        }
       @font-face {
          font-family: 'FontAwesome5_Solid';
          src: url(${require('react-native-vector-icons/Fonts/FontAwesome5_Solid.ttf')}) format('truetype');
        }
      `}</style>
        <Admin />
      </>
    )
  }
}

export default App
